import { ResourceBuilder } from '../../core/resource-builder'
import type Model from './model'

type FreeContentRequestsConfig = {
  list: {
    request: void
    response: Model[]
  }
  create: {
    request: {
      name: string
      body: string
    }
    response: void
  }
}

export default new ResourceBuilder<FreeContentRequestsConfig>('free-content')
